/**
 * English for the campaign list (card У2, boards CampList, CampGroups,
 * CampFilter, CampSaveView, CampColumns, CampLoading, CampEmpty, CampError,
 * Camp1920). Spread into `en`, so the keys are part of `TKey` and
 * `ru.campaigns.ts` must cover every one of them.
 */
export const enCampaigns = {
  "camps.title": "Campaigns",
  "camps.fold.label": "How to list the campaigns",
  "camps.fold.list": "As a list",
  "camps.fold.groups": "By group",
  "camps.fold.offers": "By offer",
  "camps.fold.buyers": "By buyer",
  "camps.columns": "Columns: {set}",
  "camps.csv": "CSV",
  "camps.rowNote": "click a row — the campaign",
  "camps.groupsNote": "{count} headers · numbers of each header are the server's",
  "camps.loadingNote": "loading {period}…",
  "camps.search": "Name, sub, id",
  "camps.retry": "Retry",
  "camps.cancel": "Cancel",

  "camps.quick.active": "Active",
  "camps.quick.myActive": "My active",
  "camps.quick.losing": "Losing",
  "camps.quick.noclicks": "No clicks",
  "camps.quick.hold50": "Hold > 50%",
  "camps.quick.archive": "Archive",

  "camps.col.name": "Campaign",
  "camps.col.status": "Status",
  "camps.col.outcome": "Lead outcome",
  "camps.band.traffic": "Traffic",
  "camps.band.conversions": "Conversions",
  "camps.band.money": "Money",
  "camps.band.custom": "Own",
  "camps.delta.hint": "Change against the comparison period",
  "camps.total": "Total, {count} {campaigns}",
  "camps.total.filtered": "Total by the filter, {count}",
  "camps.badge.losing": "Losing",
  "camps.badge.noClicks": "No clicks",
  "camps.badge.manualCost": "Spend by hand",
  "camps.badge.imported": "Import · {label}",
  "camps.import.manage": "Manage",
  "camps.import.locked": "The campaign is managed in {label} — make changes there",

  "camps.group.count": "{count}",
  "camps.group.noGroup": "No group",
  "camps.group.noOffer": "Reached no offer",
  "camps.group.noOwner": "No buyer",
  "camps.group.buyer": "Buyer {id}",
  "camps.group.spendWithoutClicks": "Spend without clicks",

  "camps.kpi.bots": "bots {pct} filtered",
  "camps.kpi.cr": "CR {cr}",
  "camps.kpi.approve": "approve {pct} of decided",
  "camps.kpi.hold": "In hold",
  "camps.kpi.inFlight": "≈ {sum} on the way",
  "camps.kpi.epc": "EPC {epc}",
  "camps.kpi.cpa": "CPA {cpa}",
  "camps.kpi.was": "was {value}",

  "camps.facet.owner": "Buyer",
  "camps.facet.source": "Source",
  "camps.facet.group": "Group",
  "camps.facet.geo": "Geo",
  "camps.facet.offer": "Offer",
  "camps.facet.status": "Status",
  "camps.facet.metrics": "Metrics",
  "camps.filter.any": "All",
  "camps.status.ACTIVE": "Active",
  "camps.status.PAUSED": "Paused",
  "camps.status.DRAFT": "Draft",
  "camps.filter.add": "Filter",
  "camps.filter.facets": "Filters",
  "camps.filter.active": "Applied filters",
  "camps.filter.remove": "Remove the filter: {name}",
  "camps.filter.edit": "Change the filter: {name}",
  "camps.filter.search": "Find: {name}",
  "camps.filter.apply": "Apply",
  "camps.filter.reset": "Reset",
  "camps.filter.nothing": "Nothing found",
  "camps.filter.loading": "Loading the options",
  "camps.filter.back": "Back",

  "camps.metrics.title": "By metrics",
  "camps.metrics.all": "all conditions at once",
  "camps.metrics.addRow": "Condition",
  "camps.metrics.field": "Metric",
  "camps.metrics.operator": "Comparison",
  "camps.metrics.value": "Value",
  "camps.metrics.remove": "Remove the condition",
  "camps.metrics.none": "No conditions yet",
  "camps.metrics.format": "Enter a number",
  "camps.metrics.counting": "Counting…",
  "camps.metrics.found": "Found {count} {campaigns}",
  "camps.metrics.saveAsView": "Save as a view",
  "camps.op.lt": "less than",
  "camps.op.lte": "at most",
  "camps.op.gt": "more than",
  "camps.op.gte": "at least",
  "camps.op.eq": "equals",
  "camps.op.neq": "does not equal",

  "camps.view.add": "Save view",
  "camps.view.toolbar": "Views",
  "camps.view.createAria": "Save the current filters as a view",
  "camps.view.chip": "View «{name}»",
  "camps.view.chipShared": "View «{name}», shared",
  "camps.view.delete": "Delete view «{name}»",
  "camps.view.more": "{n} more",
  "camps.view.moreAria": "{n} more views",
  "camps.view.title": "Save view",
  "camps.view.description": "A view keeps the filters, the grouping, the columns and the sort. The period is not kept — it is the same on every page.",
  "camps.view.name": "Name",
  "camps.view.namePlaceholder": "Losing with leads",
  "camps.view.shared": "Everyone in the workspace sees it",
  "camps.view.sharedHint": "otherwise — only you",
  "camps.view.keeps.filters": "Filters",
  "camps.view.keeps.fold": "Grouping",
  "camps.view.keeps.columns": "Columns",
  "camps.view.keeps.sort": "Sort",
  "camps.view.noFilters": "none",
  "camps.view.save": "Save view",
  "camps.view.saved": "View «{name}» saved",
  "camps.view.deleted": "View «{name}» deleted",
  "camps.sort.asc": "ascending",
  "camps.sort.desc": "descending",

  "camps.set.money": "Money",
  "camps.set.moneyWide": "Money + quality",
  "camps.set.funnel": "Funnel",
  "camps.set.quality": "Traffic quality",
  "camps.set.compare": "Comparison",
  "camps.set.mine": "Mine",
  "camps.cols.title": "Columns",
  "camps.cols.description": "Which numbers the table shows. A set is picked in one click; a ticked box makes the set yours.",
  "camps.cols.sets": "Set",
  "camps.cols.save": "Save set",
  "camps.cols.reset": "Reset",
  "camps.cols.empty": "No columns to choose from",
  "camps.cols.close": "Close",
  "camps.cols.goals": "Goals",
  "camps.cols.saveTitle": "Save the column set",
  "camps.cols.saveDescription": "The set shows on the campaign list and in reports.",
  "camps.cols.saved": "Set «{name}» saved",
  "camps.cols.order": "Order · {count}",
  "camps.cols.move": "Move «{name}» — drag, or Alt+↑/↓",
  "camps.cols.moved": "«{name}»: position {position} of {total}",

  "camps.csv.level": "Level",
  "camps.csv.group": "Group",
  "camps.csv.campaign": "Campaign",
  "camps.csv.total": "Total",
  "camps.csv.empty": "Nothing to export",
  "camps.csv.failed": "Could not export CSV",

  "camps.error.title": "Could not refresh the numbers.",
  "camps.error.stale": "The reports server did not answer. Below — the numbers as of {time}.",

  "camps.empty.first.title": "No campaigns yet",
  "camps.empty.first.body": "A campaign ties an ad to an offer: it gives a link for the ad, counts clicks and leads and shows what you earned.",
  "camps.empty.first.cta": "Create a campaign",
  "camps.empty.has": "{what} — {name}",
  "camps.empty.none": "{what} — none yet",
  "camps.empty.partner": "Partner network",
  "camps.empty.source": "Source",
  "camps.empty.offer": "Offer",
  "camps.empty.lander": "Lander",
  "camps.empty.domain": "Domain",
  "camps.empty.quiet.eyebrow": "Campaigns, but no traffic in the period",
  "camps.empty.quiet.title": "No clicks over {period}",
  "camps.empty.quiet.body": "{count} {campaigns} exist, but none got traffic over these days.",
  "camps.empty.quiet.last": "The last click was {age} ago — {day} at {time}.",
  "camps.empty.quiet.longer": "Show 30 days",
  "camps.empty.quiet.list": "Show every campaign without numbers",
  "camps.empty.filtered.title": "No campaign fits",
  "camps.empty.filtered.body": "Nothing in this period passes the filters and the conditions.",
  "camps.empty.filtered.reset": "Reset the filters",
} as const;
